import { handleActions, createAction } from 'redux-actions';
import update from 'immutability-helper';
import mapActions from '@goodwaygroup/react-map-actions';
import { LOCATION_CHANGE } from 'connected-react-router';
import qs from 'qs';
import URL from 'url-parse';

export const actions = mapActions([
    'UPDATE_WHITELABEL_KEY',
], 'ROUTER');

// Action Creators
export const updateWhitelabelKey = createAction(
    actions.UPDATE_WHITELABEL_KEY,
    ({ whitelabelKey = null, isWhitelabel = false } = {}) => ({ whitelabelKey, isWhitelabel })
);

// Reducers
const initialState = {
    parsedUrl: null,
    whitelabelKey: null,
    isWhitelabel: false
};

export default connectRouterReducer => handleActions({
    [LOCATION_CHANGE]: (state, action) => {
        const parentState = connectRouterReducer(state, action);
        const url = new URL(window.location.href, '', (input = '') => qs.parse(input, { ignoreQueryPrefix: true }));
        const origToString = url.toString;

        Object.defineProperty(url, 'toString', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: ({ onlyPath = false } = {}) => {
                if (onlyPath) {
                    return origToString.call(url, qs.stringify).replace(url.origin, '');
                }

                return origToString.call(url, qs.stringify);
            }
        });

        return update(parentState, {
            parsedUrl: { $set: url }
        });
    },
    [actions.UPDATE_WHITELABEL_KEY]: (state, action) => update(state, {
        whitelabelKey: { $set: action.payload.whitelabelKey },
        isWhitelabel: { $set: action.payload.isWhitelabel }
    })
}, initialState);



// WEBPACK FOOTER //
// ./src/services/router/duck.js